export default __webpack_public_path__ + "static/media/photo-buy.62e8069a.jpeg";